import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BACKEND_URL } from "../../config";

export const tooltipApi = createApi({
  reducerPath: "tooltipApi",
  keepUnusedDataFor: 3600,
  baseQuery: fetchBaseQuery({
    baseUrl: BACKEND_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.token;
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getTooltips: builder.query({
      query: () => "/user/portal/tooltips",
    }),
  }),
});

export const { useGetTooltipsQuery } = tooltipApi;
